import React from 'react';
import './ListSeparator.less';
import classNames from 'classnames';
import { EnvagoAria } from '../../../aria.types';

interface IListSeparatorProps {
    text: string;
    className?: string;
    isActive?: boolean;
    aria?: EnvagoAria
}

const ListSeparator = ({ text, className, aria, isActive = true }: IListSeparatorProps) => {
    return (
        <div
            {...aria}
            className={classNames('list-separator text-sm px-2 py-1 rounded', className, {
                'bg-accent': isActive,
                'bg-gray-500': !isActive,
            })}
        >
            <span>{text}</span>
        </div>
    );
};

export default ListSeparator;
